import React, { useMemo } from 'react';
import { Icon } from '../../ui/icon/Icon';
import { defaultPersonaIcon } from '../../constants/consts';
import { getClassNames } from '../../helpers/classHelpers';
import { PersonaOption } from '../../models/types';
import { AdaptiveIconProps, IconTheme } from '../../ui/icon/Icon.types';
import style from './ChatWelcome.module.scss';

type Props = {
    avatar?: AdaptiveIconProps['iconName'];
    persona?: PersonaOption;
};

const ChatWelcome: React.FC<Props> = ({ avatar, persona }) => {
    const icon = persona?.icon || persona?.avatar || avatar;
    const iconName = useMemo(() => { return icon?.startsWith('http') ? `${icon}?width=100` : icon; }, [icon]);
    if (!persona) return null;
    return (
        <div className={style['chat-welcome']}>
            {iconName && <Icon.Adaptive size={54} title={''} theme={IconTheme.accent} iconName={iconName} className={style.avatar} />}
            {!iconName && <Icon.Svg borderSize={2} size={54} title={''} iconName={defaultPersonaIcon} className={style.avatar} fill='red' borderColor='red' />}
            <span className={style.title}>{persona.welcomeTitle}</span>
            {/* Description section for the plus1 chat welcome message */}
            <p className={getClassNames(['df-helper-text'])}>
                Here's how it works:<br />
                <b>Step 1:</b> Ask your question<br />
                <b>Step 2:</b> Satisfied with your answer? You're all set.<br />
                <b>Step 3:</b> Still need help? You can create a case for the PLUS+1 Helpdesk.<br />
                Your conversation becomes the case details, with Subject and Product fields prefilled,<br />
                which you can edit before submitting.<br />
                Go ahead, ask away!
            </p>
        </div>
    );
};

export default ChatWelcome;
